export interface IResponsiveCarouselProps {
  children: React.ReactNode[];
  bgColor?: string;
}

export interface ISideButtonWrappedProps {
  isMobile: boolean;
  bgColor: string;
  isOverflow: boolean;
}

export enum Sizes {
  SPACER = 8
}
